<template>
  <div class="home-page cg-page">
    <div class="login-content">
      <div class="pt20 disflex" style="justify-content: center;position: fixed;background:url(static/images/star.png) no-repeat 0 0;max-width:750px;height: 317px;background-size: cover;align-items: flex-start;">
        <a class="logo" style="width: 150px;margin: 0 30px;" href="/"><img src="static/images/logo1.png" /></a>
      </div>
      <div class="landing-page">
        <div>
          <div class="home-prize" style="padding-top: 185px;">
            <div class="home1 ac">
              <img :src="isEN=='bur' ? '../../static/images/login-bg4.png' : '../../static/images/login-bg4.png'">
            </div>
          </div>
          <div>
            <div class="lg-bg2">
              <div class="ac mt30">
                <div class="drown-list drown-bg">
                  <div class="input-div">
                    <div class="span fs26 ac fw7 form-title">{{$t('accountLabel')}}</div>
                    <div class="input-item">
                      <input class="input" v-model="account" :placeholder="$t('accountPlaceholder')">
                    </div>
                  </div>
                  <div class="input-div mt20">
                    <div class="span fs26 ac fw7 form-title">{{$t('passwordLabel')}}</div>
                    <div class="input-item">
                      <input class="input" v-model="password" type="password" :placeholder="$t('passwordPlaceholder')">
                    </div>
                  </div>
                  <div class="disflex submit-wrap">
                    <div class="drown-li" @click="goLogin">
                      <div class="disflex day">
                        <span>{{$t('Login')}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="switch-link ac">
                    <span @click="goRegister">{{$t('noAccountGoRegister')}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="footer-content ac" style="justify-content: space-evenly;">
              <div class="icon icon2" @click="getHref('faq')">
                <img src="../../static/images/menu-icon5.png" />
                <span>{{$t('FAQs')}}</span>
              </div>
              <div class="icon icon3" @click="getHref('termsAndCondition')">
                <img src="../../static/images/menu-icon6.png" />
                <span>{{$t('TC')}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isEN: 'bur',
      account: '',
      password: ''
    }
  },
  created() {
    if (localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
  },
  methods: {
    getHref(type) {
      this.$router.push({ path: type, query: { type: type } })
    },
    goRegister() {
      this.$router.push({ path: '/reg' })
    },
    goLogin() {
      let that = this
      if (!that.account) {
        that.$utils.alertText(that.$t('accountLoginTips'), 80)
        return
      }
      if (!that.password) {
        that.$utils.alertText(that.$t('passwordLoginTips'), 80)
        return
      }

      that.$parent.loadModal(true)
      let data = {
        account: that.account,
        password: that.password
      }

      that.$api.post('/api/user/account_login', data, r => {
        that.$parent.loadModal(false)
        if (r.code == 1) {
          if (r.data && r.data.userinfo) {
            localStorage.setItem('token', r.data.userinfo.token || '')
            localStorage.setItem('mobile', r.data.userinfo.mobile || '')
          }
          that.$router.push({ path: '/' })
        } else {
          that.$utils.alertText(r.msg, 100, 2000)
        }
      })
    }
  }
}
</script>
<style scoped>
.drop-down-content{z-index:9;background:none;}
.landing-page{padding-bottom:60px;}
.cg-page{background: url(../../static/images/bg3-png.jpg) no-repeat center top #0034ae;}
.input-item{background:url(../../static/images/input-bg.png) no-repeat center center;background-size: contain;height: 102px;width: 474px;display: flex;align-items: center;padding: 0 32px;}
.input-div div span{color:#0036af;}
.input-div .input{color:#0036af;width: 100%;background: transparent;border: 0;font-size: 30px;}
.input-div .input::placeholder{color:#7d8cc8;}
.input-div .input:focus{outline: none;}
.drown-list{width: auto;margin-top: -40px;}
.drown-bg .drown-li.active::before,.drown-bg .drown-li::before{display: none;}
.drown-list .disflex{font-size: 30px;font-weight: 700;box-shadow: none;background-color: none;text-shadow: #000000 -5px 2px;margin-top: -1px;}
.day{background: url(../../static/images/login.png) no-repeat;background-size: contain;min-height: 100px;width: 320px;}
.lg-bg2{background:url(../../static/images/login-img3.png) no-repeat center 70px;}
.form-title{font-weight: 400;margin-bottom: 15px;}
.submit-wrap{margin-top: 50px;justify-content: center;}
.switch-link{margin-top: 24px;font-size: 26px;color: #fff;}
.switch-link span{cursor: pointer;text-decoration: underline;}
</style>



// WEBPACK FOOTER //
// src/page/Login.vue